module.exports = {

    // 马上代驾，白师傅，羚师傅代驾，九州代驾都是用这一版程序，功能同步更新，切换下面的配置即可切换项目，不同项目主题色不同，文字不同，都是动态的
    // 宝塔
    // 九州代驾宝塔测试环境: https://120.46.153.150:8888/3d2df085
    // 用户名：lhucebt8
    // 密码：5878c243

    // 九州代驾宝塔线上：http://124.70.4.204:8888/d02f5983
    // 用户名：ylxs0maj
    // 密码：46ab94fe

    // 羚师傅，白师傅，一个宝塔 就一个环境是线上
    // 外网：https://116.205.123.108:35958/aa5a324e
    // 内网：https://192.168.0.65:35958/aa5a324e
    // 用户名：2smc2zqx
    // 密码：f794e093




    // 九州代驾 线上环境
    // config: {
    //     'localStorage_token_name': 'access_token',
    //     'axios_timeout': 20000, // 请求超时时间20秒
    //     'axios_baseURL': 'https://super.v3.jiuzhoudaijiaapi.cn',
    //     'axios_normalURL': 'https://normal.v3.jiuzhoudaijiaapi.cn',
    //     'axios_imgURL': 'https://normal.v3.jiuzhoudaijiaapi.cn/qiniu/upload',
    //     'hash_key': 'gcss9csffhhc9z',
    //     'qnKey': '7KhrRruiqd6r3UM5IfMlKUWbyDCbo14bNw5HDbQ2',
    //     'proType': '九州',
    //     // 'proType': '马上',
    //     // 'proType': '羚师傅',
    //     // 'proType': '白师傅',
    //     'webSocket': 'wss://socket.v3.jiuzhoudaijiaapi.cn:9505?',
    //     'h5': 'https://h5.v3.jiuzhoudaijiaapi.cn/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code=',
    //     // 'service_tag': 'LOCAL',
    //     'city_tag': 'ONLINE_MAIN' //分城市
    // }



    // ----------------------------------------- v3 -----------------------------------------


    // 九州代驾 测试
    config: {
        'localStorage_token_name': 'access_token',
        'axios_timeout': 20000, // 请求超时时间20秒
        'axios_baseURL': 'https://supertest.v3.jiuzhoudaijiaapi.cn',
        'axios_normalURL': 'https://normaltest.v3.jiuzhoudaijiaapi.cn',
        'axios_imgURL': 'https://normaltest.v3.jiuzhoudaijiaapi.cn/qiniu/upload',
        'hash_key': 'gcss9csffhhc9z',
        'qnKey': '7KhrRruiqd6r3UM5IfMlKUWbyDCbo14bNw5HDbQ2',
        'proType': '九州',
        // 'proType': '马上',
        //     'proType': '羚师傅',
        //     'proType': '白师傅',
        'webSocket': 'wss://sockettest.v3.jiuzhoudaijiaapi.cn:9505?',
        'h5': 'https://h5test.v3.jiuzhoudaijiaapi.cn/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code=',
        // 'service_tag': 'LOCAL',
        'city_tag': 'ONLINE_MAIN' //分城市
    }


    // ----------------------------------------- v3 -----------------------------------------

    // 羚师傅线上 file.anxingtech.com //文件服务器 和白师傅一样
    // config: {
    //     'localStorage_token_name': 'access_token',
    //     'axios_timeout': 20000, // 请求超时时间20秒
    //     'axios_baseURL': 'https://super.anxingtech.com',
    //     'axios_normalURL': 'https://normal.anxingtech.com',
    //     'axios_imgURL': 'https://normal.anxingtech.com/qiniu/upload',
    //     'hash_key': 'gcss9csffhhc9z',
    //     'qnKey': '7KhrRruiqd6r3UM5IfMlKUWbyDCbo14bNw5HDbQ2',


    //     'proType': '羚师傅',

    //     'h5': 'https://h5.anxingtech.com/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code=',
    //     // 'service_tag': 'LOCAL',
    //     'city_tag': 'ONLINE_MAIN' //分城市
    // }
    // ----------------------------------------- v3 -----------------------------------------



    // 白师傅

    // config: {
    //     'localStorage_token_name': 'access_token',
    //     'axios_timeout': 20000, // 请求超时时间20秒
    //     'axios_baseURL': 'https://superbai.v3.jiuzhoudaijiaapi.cn',
    //     'axios_normalURL': 'https://normalbai.v3.jiuzhoudaijiaapi.cn',
    //     'axios_imgURL': 'https://normal.anxingtech.com/qiniu/upload',
    //     'hash_key': 'gcss9csffhhc9z',
    //     'qnKey': '7KhrRruiqd6r3UM5IfMlKUWbyDCbo14bNw5HDbQ2',
    //     'proType': '白师傅',
    //     'h5': 'https://h5bai.v3.jiuzhoudaijiaapi.cn/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code=',
    //     // 'service_tag': 'LOCAL',
    //     'city_tag': 'ONLINE_MAIN' //分城市
    // }

    // ----------------------------------------- v3 -----------------------------------------

    // 九州代驾 Dev测试环境环境

    // config: {
    //     'localStorage_token_name': 'access_token',
    //     'axios_timeout': 20000, // 请求超时时间20秒
    //     'axios_baseURL': 'https://superdev.v3.jiuzhoudaijiaapi.cn',
    //     'axios_normalURL': 'https://normaldev.v3.jiuzhoudaijiaapi.cn',
    //     'axios_imgURL': 'https://normaldev.v3.jiuzhoudaijiaapi.cn/qiniu/upload',
    //     'hash_key': 'gcss9csffhhc9z',
    //     'qnKey': '7KhrRruiqd6r3UM5IfMlKUWbyDCbo14bNw5HDbQ2',
    //     'proType': '九州',
    // 'proType': '马上',
    //     'proType': '羚师傅',
    //     'proType': '白师傅',
    //     // 'webSocket': 'ws://192.168.100.9:9505?',
    //     'webSocket': 'wss://socketdev.v3.jiuzhoudaijiaapi.cn:9506?',
    //     'h5': 'https://h5.v3.dev.jiuzhouapi.com/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code='
    // }


    // ----------------------------------------- v3 -----------------------------------------


    // 九州代驾 Dev2 农行支付测试环境环境

    // config: {
    //     'localStorage_token_name': 'access_token',
    //     'axios_timeout': 20000, // 请求超时时间20秒
    //     'axios_baseURL': 'https://superdev2.v3.jiuzhoudaijiaapi.cn',
    //     'axios_normalURL': 'https://normaldev2.v3.jiuzhoudaijiaapi.cn',
    //     'axios_imgURL': 'https://normaldev2.v3.jiuzhoudaijiaapi.cn/qiniu/upload',
    //     'hash_key': 'gcss9csffhhc9z',
    //     'qnKey': '7KhrRruiqd6r3UM5IfMlKUWbyDCbo14bNw5HDbQ2',
    //      'proType': '九州',
    // 'proType': '马上',
    //     'proType': '羚师傅',
    //     'proType': '白师傅',
    //     // 'webSocket': 'ws://192.168.100.9:9505?',
    //     'webSocket': 'wss://socketdev2.v3.jiuzhoudaijiaapi.cn:9510?',
    //     'h5': 'https://h5.v3.dev2.jiuzhouapi.com/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code='
    // }



    // ----------------------------------------- v3 -----------------------------------------


    // 极马测试
    // config: {
    //   'localStorage_token_name': 'access_token',
    //   'axios_timeout': 20000, // 请求超时时间20秒
    //   'axios_baseURL': 'https://superjm.v3.test.jiuzhouapi.com',
    //   'axios_normalURL': 'https://normaljm.v3.test.jiuzhouapi.com',
    //   'axios_imgURL': 'https://normaljm.v3.test.jiuzhouapi.com/qiniu/upload',
    //   'hash_key': 'gcss9csffhhc9z',

    //   'h5': 'https://h5.v3.test.jiuzhouapi.com/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code=',
    //   // 'service_tag': 'LOCAL',
    //   'city_tag': 'ONLINE_MAIN' //分城市
    // }


    // ----------------------------------------- v3 -----------------------------------------

    // 极马线上
    // config: {
    //   'localStorage_token_name': 'access_token',
    //   'axios_timeout': 20000, // 请求超时时间20秒
    //   'axios_baseURL': 'https://superjm.jmlkj.cn',
    //   'axios_normalURL': 'https://normaljm.jmlkj.cn',
    //   'axios_imgURL': 'https://normaljm.jmlkj.cn/qiniu/upload',
    //   'hash_key': 'gcss9csffhhc9z',
    //   'h5': 'https://h5.v3.test.jiuzhouapi.com/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code=',
    //   // 'service_tag': 'LOCAL',
    //   'city_tag': 'ONLINE_MAIN' //分城市
    // }


    // ----------------------------------------- v3 -----------------------------------------



    // 九州代驾 测试故障
    // config: {
    //     'localStorage_token_name': 'access_token',
    //     'axios_timeout': 20000, // 请求超时时间20秒
    //     'axios_baseURL': 'https://supera.v3.jiuzhoudaijiaapi.cn',
    //     'axios_normalURL': 'https://normala.v3.jiuzhoudaijiaapi.cn',
    //     'axios_imgURL': 'https://normala.v3.jiuzhoudaijiaapi.cn/qiniu/upload',
    //     'hash_key': 'gcss9csffhhc9z',
    // 'qnKey': '7KhrRruiqd6r3UM5IfMlKUWbyDCbo14bNw5HDbQ2',
    //     // 'webSocket': 'ws://192.168.100.9:9505?',
    //     'webSocket': 'wss://socketa.v3.jiuzhoudaijiaapi.cn:9505?',
    //     'h5': 'https://h5a.v3.jiuzhoudaijiaapi.cn/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code='
    // }

    // ----------------------------------------- v3 -----------------------------------------










}


// WEBPACK FOOTER //
// ./src/utils/config.js